import { MatDatepickerIntl } from '@angular/material/datepicker';

export function getDanishMatDatepickerIntl() {
  const intl = new MatDatepickerIntl();
  intl.calendarLabel = 'Kalender';
  intl.openCalendarLabel = 'Åbn kalender';
  intl.closeCalendarLabel = 'Luk kalender';
  intl.prevMonthLabel = 'Forrige måned';
  intl.nextMonthLabel = 'Næste måned';
  intl.prevYearLabel = 'Forrige år';
  intl.nextYearLabel = 'Næste år';
  intl.switchToMonthViewLabel = 'Skift til månedsvisning';
  intl.switchToMultiYearViewLabel = 'Vælg måned og år';

  return intl;
}
